import {
    SET_SHIPMENTS_DATA_LOADING,
    SET_SHIPMENTS,
    SET_SEARCH_SHIPMENTS,
    SET_SHIPMENT_FILTERS_VISIBILITY,
    SET_SEARCH_TRACKING_NO_DATA_LOADING,
    GET_SEARCH_TRACKING_NO,
} from "../actions/types";

const initialState = {
    isLoading: false,
    shipmentsData: [],
    searchShipments: [],
    isShipmentFiltersOpen: false,
    suggestTrackingNo: [],
    isSuggestedTrackingNoLoading: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_SHIPMENTS_DATA_LOADING:
            return {
                ...state,
                isLoading: payload,
            };
        case SET_SHIPMENTS:
            return {
                ...state,
                shipmentsData: payload,
                isLoading: false,
            };
        case SET_SEARCH_SHIPMENTS:
            return {
                ...state,
                searchShipments: payload,
            };
        case SET_SHIPMENT_FILTERS_VISIBILITY:
            return {
                ...state,
                isShipmentFiltersOpen: payload,
            }
        case SET_SEARCH_TRACKING_NO_DATA_LOADING:
            return {
                ...state,
                isSuggestedTrackingNoLoading: true,
            };
        case GET_SEARCH_TRACKING_NO:
            return {
                ...state,
                suggestTrackingNo: payload,
                isSuggestedStatusLoading: false,
            };

        default:
            return state;
    }
}